import { AppPrices } from '@galaxy/marketplace-apps';
import { Currency } from '@galaxy/billing';
import { ListItemWithPageData } from '../product-page.service';
import { DeliveryMethod, ItemType } from '@vendasta/marketplace-apps';
import { RequiredItem } from '@vendasta/marketplace-apps/lib/_internal/objects/item';

export interface ProductListPageTableRow {
  name?: string;
  retailPrice?: AppPrices;
  retailCurrency?: Currency;
  iconUrl?: string;
  learnMoreUrl?: string;
  type: ItemType;
  requiredItems: RequiredItem[];
  deliveryMethod: DeliveryMethod;
}

export function convertListItemsAndPricingToTableDataRow(
  listItemWithPageData: ListItemWithPageData,
  appPrices: AppPrices[],
  currency: Currency,
): ProductListPageTableRow[] {
  const productListPageTableRows = [] as ProductListPageTableRow[];

  listItemWithPageData.items.forEach((item) => {
    const appPrice = appPrices.find((appPrice) => item.itemId === appPrice.appId);

    productListPageTableRows.push({
      name: item.name,
      retailPrice: appPrice,
      retailCurrency: currency,
      iconUrl: item.iconUrl,
      learnMoreUrl: item.learnMoreUrl,
      type: item.type,
      requiredItems: item.requiredItems,
      deliveryMethod: item.deliveryMethod,
    } as ProductListPageTableRow);
  });

  return productListPageTableRows;
}
